import React from "react";
import Message from "../../../../pages/components/message";
import {MessageSections} from "../../../../pages/components/message/message";
import BarekamText from "../../../../pages/components/text";
import moment from "moment/moment";
import {OrderModel} from "../../../../pages/shared/models/order/order-item.model";

export const GroupCardRowData = ({value, variant}: GroupCardRowDataProps) => {
    switch (variant) {
        case "text":
            return (
                <BarekamText variant={"m"}>
                    {value}
                </BarekamText>
            )
        case "warehouse":
            return (
                <BarekamText variant={"m"}>
                    {value.city}
                </BarekamText>
            )
        case "date":
            return (
                <BarekamText variant={"m"}>
                    {value ? moment(value as number).format('DD/MM/YYYY') : 'N/A'}
                </BarekamText>
            )
        case "totalWeight":
            return (
                <BarekamText variant={"m"}>
                    {value ? value.reduce((previousValue: number, order: OrderModel) => previousValue + (order.weight || 0), 0) : 0}
                    {' '}
                    <Message messageKey={'kg'} sectionId={MessageSections.MAIN}/>
                </BarekamText>
            )
        case "totalCount":
            return (
                <BarekamText variant={"m"}>
                    {value ? value.length : 0}
                </BarekamText>
            )
    }
}

interface GroupCardRowDataProps {
    value: any,
    variant: 'date' | 'text' | 'warehouse' | 'totalWeight' | 'totalCount'
}